import { render, staticRenderFns } from "./LayoutPickup.vue?vue&type=template&id=5559cd40&"
import script from "./LayoutPickup.vue?vue&type=script&lang=js&"
export * from "./LayoutPickup.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPickup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports